import { useEvents } from '@api/useEvents'
import { Form, Input, Select } from 'antd'
import type React from 'react'
import { useEffect } from 'react'

const { Option } = Select

interface CreateNewEventFormProps {
  selectedType: string
  setSelectedType: (type: string) => void
  name: string
  setName: (name: string) => void
}

const CreateNewEventForm: React.FC<CreateNewEventFormProps> = ({ selectedType, setSelectedType, name, setName }) => {
  const { metadataQuery } = useEvents()
  const { data: metadata, isPending, isError } = metadataQuery

  useEffect(() => {
    if (metadata?.types && metadata.types.length > 0 && setSelectedType) {
      setSelectedType(metadata.types[0])
    }
  }, [metadata, setSelectedType])

  if (isPending) return <p>Loading...</p>
  if (isError) return <p>Error...</p>

  return (
    <Form layout='vertical'>
      <Form.Item label='Type'>
        <Select placeholder='Select Type' onChange={(value) => setSelectedType(value)}>
          {metadata?.types.map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label='Name'>
        <Input placeholder='Enter Name' value={name} onChange={(e) => setName(e.target.value)} />
      </Form.Item>
    </Form>
  )
}

export default CreateNewEventForm
